// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__RNyhN","content":"Hero_content__mfevx","productBadge":"Hero_productBadge__TpaxA","button":"Hero_button__oPPcV","image":"Hero_image__gArpB"};